import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalsSingleton } from '../../../app/core/GlobalsSingleton';


@Component({
	selector: 'PatientententypSelektor',
	templateUrl: 'PatiententypSelektor.html'
})
export class PatiententypSelektorComponent {

	text: string;

	@Input()
	ausgewaehlterPatiententyp: string;
	@Output()
	ausgewaehlterPatiententypChange = new EventEmitter<string>();


	constructor(public globals: GlobalsSingleton) {
	}





	/**	=== Visionet(sl) ==========
	 *
	 *	Klick auf Patientengruppe (Kind, Erwachsener, Schwangere)
	 */
	setPatientType(patientType : string) : void {
		this.ausgewaehlterPatiententyp = patientType
		this.ausgewaehlterPatiententypChange.emit(patientType); // hier ändern wir die Variable "ausgewaehlterPatiententyp" in der übergeordn eten Komponente
	}

	getSelectedCssClass(buttonname : string) : string {
		if (buttonname == this.ausgewaehlterPatiententyp) {
			return "patient-ausgewaehlt";
		}
		return "";
	}

}



// WEBPACK FOOTER //
// ./src/components/Suche/PatiententypSelektor/PatiententypSelektor.ts